export const SET_TTFF_START = 'SET_TTFF_START';

export function setTTFFStart(time) {
    return {
        type: SET_TTFF_START,
        payload: time,
    };
}
